import { Component, OnDestroy, inject } from "@angular/core";
import { Subscription } from "rxjs";
import { CHANGE_ADDRESS_TEXT } from "./change-address-text";
import { TranslateService, TranslatePipe } from "@ngx-translate/core";
import { MatDialogTitle, MatDialogContent, MatDialogActions, MatDialogClose } from "@angular/material/dialog";
import { CdkScrollable } from "@angular/cdk/scrolling";
import { MatButton } from "@angular/material/button";

@Component({
    selector: "lib-change-address-dialog",
    templateUrl: "change-address-dialog.component.html",
    styleUrls: ["./_change-address-dialog.component.scss"],
    imports: [MatDialogTitle, CdkScrollable, MatDialogContent, MatDialogActions, MatButton, MatDialogClose, TranslatePipe]
})
export class ChangeAddressDialogComponent implements OnDestroy {
	private translate = inject(TranslateService);

	private translateSubscription: Subscription;
	protected changeAddressText: string;

	constructor() {
		this.changeAddressText =
			CHANGE_ADDRESS_TEXT[this.translate.getCurrentLang()] ||
			CHANGE_ADDRESS_TEXT.en;
		this.translateSubscription = this.translate.onLangChange.subscribe(
			(e) =>
				(this.changeAddressText =
					CHANGE_ADDRESS_TEXT[e.lang] || CHANGE_ADDRESS_TEXT.en)
		);
	}

	ngOnDestroy(): void {
		this.translateSubscription.unsubscribe();
	}
}
